import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AddeditLoadscheduleComponent } from '../components/loadschedules/addedit-loadschedule/addedit-loadschedule.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  open(AddeditLoadscheduleComponent: AddeditLoadscheduleComponent, arg1: { width: string; height: string; maxWidth: string; maxHeight: string; panelClass: string; disableClose: boolean; data: { task: string; fsLoadId: number; marketId: number; scheduleTypeId: string | null; }; }) {
    throw new Error('Method not implemented.');
  }
  constructor(private dialog: MatDialog) {}

  openDialog(component: any, data?: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = data;
    this.dialog.open(component, dialogConfig);
  }
}
